module.exports = __webpack_public_path__ + "img/sala.80660e54.png";